"use client";
import { useParams, useSearchParams } from "next/navigation";
import { Stack } from "@mui/material";

import { observer, useStore } from "../../../service/mobx";
import FilterChip from "../../../component/Chip/Filter";
import { filterChipScrollSx } from "../../../view/search/Filters";

function FilterChips({ chips = [], small }) {
  const { analytics, device, reader } = useStore();
  const { publisher, paperID } = useParams();
  const searchParams = useSearchParams();
  const query = searchParams.size === 0 ? "" : "?" + searchParams.toString();

  return (
    <Stack
      useFlexGap
      spacing={1}
      direction="row"
      zIndex={1}
      p={{ compact: 2, expanded: 3, large: 0 }}
      mx={{ compact: -2, expanded: -3, large: 0 }}
      sx={device.isDesktop ? undefined : filterChipScrollSx}
      flexWrap={`${
        device.isDesktop || (reader.whiteLabelled && device.isTablet)
          ? ""
          : "no"
      }wrap`}
    >
      {chips.map(([label, , , url]) => (
        <FilterChip
          key={label}
          label={label}
          small={small}
          href={`/docs/${publisher}/${paperID}/${
            reader.tab === url ? reader.viewing : url
          }${query}`}
          selected={reader.tab === url}
          onClick={() => {
            analytics.track.event("Related Filter", {
              type: label,
              value: url
            });
          }}
        />
      ))}
    </Stack>
  );
}
export default observer(FilterChips);
